module.exports = "<router-outlet  *ngIf=\"globals.checkingRefreshToken\"></router-outlet>"